// src/api/apiJobOrders.js
import transport from "../utils/axios";

export const getProgramJobOrders = async (programId) => {
    const response = await transport.get(`/programs/${programId}/job-orders`);
    return response.data;
};

export const createJobOrder = async (programId, data) => {
    const response = await transport.post(`/programs/${programId}/job-orders`, data);
    return response.data;
};

export const updateJobOrder = async (jobOrderId, data) => {
    const response = await transport.put(`/job-orders/${jobOrderId}`, data);
    return response.data;
};

export const getJobOrder = async (jobOrderId) => {
    const response = await transport.get(`/job-orders/${jobOrderId}`);
    return response.data;
};

export const exportJobOrderToPdf = async (jobOrderId, data) => {
    return await transport.post(`/job-orders/${jobOrderId}/export-pdf`, data, { responseType: 'blob' });
};
